// import node module libraries
import {Fragment} from 'react';
import {Breadcrumb, Card, Col, Row, Tab} from 'react-bootstrap';

// import custom components
// import sub components
import ClassesListItems from './ClassesListItems';

const BulletinnotesClasses = () => {

    return (
        <Fragment>
            <Tab.Container defaultActiveKey="list">
                <Row>
                    <Col lg={12} md={12} sm={12}>
                        <div className="border-bottom pb-4 mb-4 d-flex align-items-center justify-content-between">
                            <div className="mb-3 mb-md-0">
                                <h1 className="mb-1 h2 fw-bold">
                                    Bulletin de notes
                                </h1>
                                <Breadcrumb>
                                    <Breadcrumb.Item href="/">
                                        Accueil
                                    </Breadcrumb.Item>
                                    <Breadcrumb.Item active>Bulletin de notes</Breadcrumb.Item>
                                </Breadcrumb>
                            </div>
                        </div>
                    </Col>
                </Row>

                <Tab.Content>

                    <Tab.Pane eventKey="list" className="pb-4">
                        <Card className="mb-5 ">
                            <Card.Body className="p-0">
                                {/* BulletinnotesClasses in list view */}
                                <ClassesListItems/>
                                {/* end of BulletinnotesClasses in list view */}
                            </Card.Body>
                        </Card>
                    </Tab.Pane>
                </Tab.Content>
            </Tab.Container>
        </Fragment>
    );
};
export default BulletinnotesClasses;
